import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Alert, AlertType } from '../model/alert.model';

/**
 * * Serviço de Alertas (mensageria).
 */
@Injectable({
  providedIn: 'root'
})
export class AlertService {

  /**
   * * Alerta controlado pelo serviço.
   */
  private readonly message:
    BehaviorSubject<Alert | null> = new BehaviorSubject<Alert | null>(null);

  constructor() {}

  private showMessage(messageType: AlertType, message: string, title: string): void {
    this.message.next(new Alert(messageType, title, message));
  }

  /**
   * * Mostrar alerta de erro.
   * @param message mensagem
   * @param action título
   */
  showError(message: string, action: string = 'Erro'): void {
    action = action == null ? 'Falha' : action;
    this.showMessage(AlertType.Error, message, action);
  }

  /**
   * * Mostrar alerta de aviso.
   * @param message mensagem
   * @param action título
   */
  showWarning(message: string, action: string = 'Atenção'): void {
    this.showMessage(AlertType.Warning, message, action);
  }

  /**
   * * Mostrar alerta de informação.
   * @param message mensagem
   * @param action título
   */
  showInfo(message: string, action: string = 'Aviso'): void {
    this.showMessage(AlertType.Info, message, action);
  }

  /**
   * * Mostrar alerta de sucesso.
   * @param message mensagem
   * @param action título
   */
  showSuccess(message: string, action: string = 'Sucesso'): void {
    this.showMessage(AlertType.Success, message, action);
  }

  /**
   * * Último alerta a ser mostrado (também pode ser nulo).
   */
  get alert(): Observable<Alert | null> {
    return this.message.asObservable();
  }

  /**
   * * Limpar mensagens.
   */
  clear(): void {
    this.message.next(null);
  }


}
